export interface Filterable {
  filterObject: FilterObject;
}

export interface FilterObject {
  key: string;
  value: string;
  keyDescription: string;
}

export type TConditionOperator = 'EQ' | 'NE' | 'GT' | 'GTE' | 'LT' | 'LTE';

// operators that compare a numeric field against a single bound; only
// offered for keys declared numeric (see AdvancedFilter's numericKeys)
export const RANGE_OPERATORS: readonly TConditionOperator[] = [
  'GT',
  'GTE',
  'LT',
  'LTE',
];

export const isRangeOperator = (operator: TConditionOperator): boolean =>
  RANGE_OPERATORS.includes(operator);

export type TCondition = {
  type: 'CONDITION';
  key?: string;
  values: Filterable[];
  operator: TConditionOperator;
  index: number;
};

export type TGroupOerator = 'OR' | 'AND';

export type TGroup = {
  type: 'GROUP';
  operator: TGroupOerator;
  values: (TCondition | TGroup)[];
  index: number;
};

export type ApiFilterItem = {
  key: string;
  value: string;
  descriptor: {
    title?: string;
    full_name?: string;
    avatar?: string;
  };
};
